export default "__VITE_ASSET__DehIbnha__"